  <template>
      <v-toolbar
              color="primary"
              dark
              fixed
              app
              clipped-left
              dense
      >
          <v-toolbar-side-icon v-if="showNavigationDrawerIcon" @click.stop="toggleLeftNavBar()"/>
          <!--<img
                  src="@/assets/img/IVE/logo_retriever_bianco.png"
                  width="50"
                  height="auto"
          ></img>-->
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-toolbar-items>


              <!-- USER NOTIFICATION -->
  <!--            <v-menu
                      offset-y
                      fixed
                      absolute
                      :close-on-content-click="false"
              >
                  <v-btn :icon="tabletAndDown()"
                         id="notificationButton"
                         slot="activator"
                         flat
                         small
                         class="text-lowercase"
                         @click="toggleGlobalNotifications()"
                  >
                      <v-badge
                              id="notificationBadge"
                              right
                              overlap
                              color="orange"
                              class="text-xs-center"
                      >
                          <template
                                  v-if="globalNotificationsNotDismissed.length > 0"
                                  v-slot:badge
                          >
                              <span id="notificationLength">{{ notificationsNotDismissedNumber }}</span>
                          </template>
                          <span
                                  id="notificationHeader"
                                  class="text-xs-center hidden-sm-and-down"
                          >
                                {{ $t('globalControls.notifications.header') }}
                          </span>
                          <v-icon
                                  id="notificationIcon"
                                  :right="!tabletAndDown"
                          >
                              mdi-bell
                          </v-icon>
                      </v-badge>
                  </v-btn>
              </v-menu>-->

              <!-- HELP BUTTON -->
              <v-btn :icon="tabletAndDown()"
                     flat
                     small
                     @click="navigate('/help')"
              >
                  <span class="hidden-sm-and-down pr-2">HELP</span>
                  <v-icon :right="!tabletAndDown">
                      mdi-help-circle-outline
                  </v-icon>
              </v-btn>

              <!-- USER PANEL WITH USER ACTIONS -->
              <v-menu offset-y>
                  <v-btn :icon="tabletAndDown()"
                         slot="activator"
                         flat
                         small
                         class="text-lowercase"
                  >
                      <v-chip
                              v-if="userInfo.role==='ADMIN'"
                              color="red"
                              small
                              class="white--text hidden-sm-and-down"
                      >
                          Admin
                      </v-chip>
                      <v-chip
                              v-else-if="userInfo.role==='IVE_ADMIN'"
                              color="orange"
                              small
                              class="white--text hidden-sm-and-down"
                      >
                          IVE Admin
                      </v-chip>
                      <span class="hidden-sm-and-down">{{ userInfo.username }}</span>
                      <v-icon :right="!tabletAndDown">
                          mdi-account
                      </v-icon>
                  </v-btn>

                  <!-- USER ACTIONS -->
                  <v-list id="userActionsList">
                      <v-list-tile>
                          <v-flex xs12>
                              <v-chip
                                      v-if="userInfo.role==='ADMIN'"
                                      color="red"
                                      small
                                      class="white--text"
                              >
                                  A
                              </v-chip>
                              <v-chip
                                      v-else-if="userInfo.role==='IVE_ADMIN'"
                                      color="orange"
                                      small
                                      class="white--text"
                              >
                                  IA
                              </v-chip>
                              <span class="ml-2">{{ userInfo.username }}</span>
                          </v-flex>
                      </v-list-tile>
                      <v-divider></v-divider>

                      <v-list-tile
                              v-for="(userAction, index) in userActions"
                              :key="index"
                              @click="navigate(userAction.path)"
                      >
                          <v-list-tile-action>
                              <v-icon>{{ userAction.icon }}</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                              <v-list-tile-title>{{ userAction.name }}</v-list-tile-title>
                          </v-list-tile-content>
                      </v-list-tile>
                  </v-list>
              </v-menu>
          </v-toolbar-items>
      </v-toolbar>
  </template>

  <script>
      import {mapGetters, mapState,} from "vuex";
      import RouterService from "@/helpers/RouterService";
      import GlobalNotificationsPanel from "@/components/GlobalControls/Notifications/GlobalNotificationsPanel";

      export default {
          name: "AppToolbar",
          components: {
              GlobalNotificationsPanel,
          },
          computed: {
              ...mapState({}),
              ...mapGetters("AppState", {
                      isLeftNavDrawer: "isLeftNavDrawer",
                      isLeftTempNavDrawer: "isLeftTempNavDrawer",
                      isGlobalNotificationsPanel: "isGlobalNotificationsPanel",
                  }
              ),
              ...mapGetters("UserState", {
                      userInfo: "getUserInfo",
                      globalNotifications: "getGlobalNotifications",
                      globalNotificationsNotDismissed: "getGlobalNotificationsNotDismissed",
                  }
              ),
              showNavigationDrawerIcon() {
                  return this.$route.meta.showNavigationDrawer;
              },
              notificationsNotDismissedNumber() {
                  if (this.globalNotificationsNotDismissed.length > 99) {
                      return "99+";
                  }
                  return this.globalNotificationsNotDismissed.length;
              },
              userActions() {
                  return this.userActionsAll[this.userInfo.role];
              }
          },
          props: ["title"],
          data() {
              return {
                  userActionsAll: {
                      ADMIN: [ // The actions related to the ADMIN PANEL
                          {
                              name: "Settings",
                              id: "admin-settings",
                              icon: "mdi-settings",
                              path: "/settings",
                          },
                          /*{
                              name: "Go to Lab",
                              id: "admin-goToLab",
                              icon: "mdi-flask-outline",
                              path: "/lab",
                          },*/
                          {
                              name: "See Tutorial",
                              id: "tutorial",
                              icon: "mdi-library-video",
                              path: "/tutorial",
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      USER: [ // The actions related to the USER PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      USER_CHAT: [ // The actions related to the USER CHAT PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      USER_INNOVATION: [ // The actions related to the USER PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      CUSTOMER_INNOVATION: [
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      CUSTOMER_CHAT_INNOVATION: [
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      ADMIN_INNOVATION: [ // The actions related to the USER PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      APPROVER_INNOVATION: [ // The actions related to the USER PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                    RADAR_INNOVATION: [ // The actions related to the USER PANEL
                      {
                        name: 'Settings',
                        id: 'settings',
                        icon: 'mdi-settings',
                       path: '/settings'
                      },
                      {
                        name: "Logout",
                        icon: "mdi-logout-variant",
                        path: {name: "HomePage", params: {isLogout: true}},
                      },
                    ],
                      IVE_ADMIN: [ // The actions related to the USER PANEL
                          {
                              name: 'Settings',
                              id: 'settings',
                              icon: 'mdi-settings',
                              path: '/settings'
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                      LAB: [ // The actions related to the LAB
                          {
                              name: "Go back",
                              icon: "mdi-keyboard-return",
                              path: "*goBack*",
                          },
                          {
                              name: "Logout",
                              icon: "mdi-logout-variant",
                              path: {name: "HomePage", params: {isLogout: true}},
                          },
                      ],
                  },
              };
          },
          methods: {
              toggleGlobalNotifications() {
                  this.$store.dispatch("AppState/setGlobalNotificationsPanel", !this.isGlobalNotificationsPanel);
              },
              toggleLeftNavBar() {
                  let leftNavDrawer = !this.isLeftNavDrawer;
                  this.$store.dispatch("AppState/setLeftNavDrawer", leftNavDrawer);
              },
              navigate(path) {
                  console.log("APP.TOOLBAR - NAVIGATE TO : ", path);
                  RouterService.goTo(path);
              },
              tabletAndDown() {
                  return this.$vuetify.breakpoint.name === "xs" ||
                      this.$vuetify.breakpoint.name === "sm";
              }
          },
      };
  </script>

  <style lang="scss" scoped>

  </style>
